import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { stringifyFacets } from '../../../utils/products';
import classNames from 'classnames/bind';
import styles from './index.scss';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';

const cx = classNames.bind(styles);

export default function SelectedFiltersTab({
  selectedFilterArray,
  selectedFiltersQuery,
  replaceInHistory,
  isEarlyAccessUser,
  isUserScrolling,
  setisUserScrolling,
  priorityDeliverySLPTagsConfig
}) {
  const priceRevealPLPBannerAvailable = document.getElementById('priceRevealPLPBanner');
  const [removedFilterAnnouncement, setRemovedFilterAnnouncement] = useState('');
  const location = useLocation();
  const selectedFiltersMainDivStyle = {
    top: isEarlyAccessUser || priceRevealPLPBannerAvailable ? '75px' : '50px'
  };

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setisUserScrolling(true);
    } else {
      setisUserScrolling(false);
    }
  };

  const handleDeselectFilter = (item) => {
    if (selectedFiltersQuery) {
      // Update the filters query by removing the selected filter
      const updatedFiltersQuery = { ...selectedFiltersQuery };
      updatedFiltersQuery[item.facetname] = updatedFiltersQuery[item.facetname].filter(
        value => value !== item.facetvalue
      );
      if (updatedFiltersQuery[item.facetname].length === 0) {
        delete updatedFiltersQuery[item.facetname];
      }
      // Update the facets with the new filters
      replaceInHistory({
        facets: stringifyFacets(updatedFiltersQuery)
      });
    } else {
      let updatedFilterArray = [...selectedFilterArray];
      // Remove the filter from the updated filter array
      updatedFilterArray = updatedFilterArray.filter(
        filter => !(filter.facetname === item.facetname && filter.facetvalue === item.facetvalue)
      );
      // Update the facets with the new filters
      const facets = updatedFilterArray.reduce((acc, filter) => {
        if (!acc[filter.facetname]) {
          acc[filter.facetname] = [];
        }
        acc[filter.facetname].push(filter.facetvalue);
        return acc;
      }, {});
      replaceInHistory({
        facets: stringifyFacets(facets)
      });
    }

    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'top filter remove',
      event_label: item?.facetvalue
    });

    setRemovedFilterAnnouncement(`Filter removed: ${item.facetname} - ${item.facetvalue}`);
  };

  const getDeliveryFacetName = facetvalue => {
    const configDeliveryFacets = priorityDeliverySLPTagsConfig?.FILTERS_BUCKET;
    const configFacetValues = configDeliveryFacets?.values || [];
    const selectedDeliveryFacet = configFacetValues.find(
      configFacetValue => configFacetValue?.code === facetvalue
    );
    return selectedDeliveryFacet ? selectedDeliveryFacet?.name : facetvalue;
  };

  useEffect(() => {
    if (selectedFilterArray?.length > 0) window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [selectedFilterArray]);
  const filteredSelectedFilterArray = Array.isArray(selectedFilterArray)
    ? selectedFilterArray.filter(item => {
        const name = item && item.facetname != null ? String(item.facetname).trim() : '';
        const value = item && item.facetvalue != null ? String(item.facetvalue).trim() : '';
        if (!name || !value) return false;
        const invalid = ['undefined', 'null'];
        return !invalid.includes(name.toLowerCase()) && !invalid.includes(value.toLowerCase());
      })
    : []; // when no filters data is correctly defined
  return (
    <>
    <div
      aria-live="polite"
      aria-atomic="true"
      aria-relevant="additions text"
      style={{ position: 'absolute', left: '-9999px', height: '1px', width: '1px', overflow: 'hidden' }}
    >
      {removedFilterAnnouncement}
    </div>
    {filteredSelectedFilterArray && filteredSelectedFilterArray?.length > 0 && (
      <div
        className={cx(
          'selected-filters-main-div',
          isUserScrolling ? 'selected-filters-selected-scoller' : ''
        )}
        style={selectedFiltersMainDivStyle}
      >
        <div className={cx('selected-filters-parent-div')}>
          {/* Render a button for each selected filter */}
          {filteredSelectedFilterArray
            .slice()
            .reverse()
            .map((item, index) => (
              <button
                key={index}
                className={cx('selected-filter-button')}
                style={{
                  textTransform: item.facetname === 'sla' ? 'capitalize' : 'none'
                }}
                onClick={() => handleDeselectFilter(item)}
                aria-label={`Remove Applied Filter: ${item.facetname === 'sla' ? getDeliveryFacetName(item.facetvalue) : item.facetvalue}.`}
              >
                {item.facetname === 'sla' ? getDeliveryFacetName(item.facetvalue) : item.facetvalue}
              </button>
            ))}
          {/* Render a "Clear All" button if there are two or more selected filters */}
          {Array.isArray(filteredSelectedFilterArray) && filteredSelectedFilterArray.length >= 2 && (
            <button
              className={cx('clear-all-button')}
              onClick={() => {
                // Clear all selected filters
                replaceInHistory({
                  facets: stringifyFacets({})
                });

                gtmEventPush({
                  event: 'buttonTap',
                  event_category: 'buttonTap',
                  event_action: 'clear all ',
                  event_label: filteredSelectedFilterArray
                    .map(selFilt => selFilt.facetvalue)
                    .join(',')
                });
              }}
              aria-label='Clear all filters'
            >
              Clear All
            </button>
          )}
        </div>
      </div>
    )}
    </>
  );
}